"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
require("@/components/overlay/popover/semantics/more-menu");
const utils_1 = require("@/utils");
require("@/components/common/list-item/domain/user-item");
const MENU_ACTIONS = [
    { value: 'edit', label: '수정' },
    { value: 'delete', label: '삭제', tone: 'danger' },
];
/**
 * 댓글 목록의 개별 항목.
 * 작성자(아바타·이름·시간), 본문(기본 슬롯), 답글 버튼, 수정/삭제 메뉴로 구성됩니다.
 * 대댓글은 slot="replies"에 중첩된 mm-comment-item을 배치합니다.
 */
let CommentItem = class CommentItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.author = '';
        this.datetime = '';
        this.avatarSrc = '';
        this.replyLabel = '';
        this.editable = false;
    }
    render() {
        return (0, lit_1.html) `
      <article>
        <mm-user-item
          size="medium"
          label=${this.author}
          description=${this.datetime}
          avatar-src=${this.avatarSrc}
        >
          ${this.renderMenu()}
        </mm-user-item>

        <slot></slot>

        ${this.renderReplyButton()}

        <slot name="replies"></slot>
      </article>
    `;
    }
    renderReplyButton() {
        if (!this.replyLabel)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-button variant="ghost" @click=${() => this.emitAction('reply')}>
        ${this.replyLabel}
      </mm-button>
    `;
    }
    renderMenu() {
        if (!this.editable)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-more-menu
        slot="trailing"
        aria-label="댓글 메뉴"
        .actions=${MENU_ACTIONS}
        @action=${this.handleMenuAction}
      ></mm-more-menu>
    `;
    }
    emitAction(type) {
        (0, utils_1.emit)(this, type);
    }
    // 메뉴의 action은 여기서 끊고, 댓글 단위의 edit·delete로 다시 알린다.
    handleMenuAction(event) {
        event.stopPropagation();
        this.emitAction(event.detail.value);
    }
};
CommentItem.styles = (0, lit_1.css) `
    :host {
      display: block;
      --comment-item-gap: var(--space-2);
      position: relative;
    }

    article {
      display: flex;
      flex-direction: column;
      gap: var(--comment-item-gap);
      position: relative;
    }

    mm-button {
      align-self: flex-start;
    }

    slot[name='replies']::slotted(*) {
      margin: var(--space-4) 0 0;
      padding-left: var(--space-4);
      box-shadow: inset 2px 0 0 var(--border-color);
      position: relative;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CommentItem.prototype, "author", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CommentItem.prototype, "datetime", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-src' })
], CommentItem.prototype, "avatarSrc", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'reply-label' })
], CommentItem.prototype, "replyLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], CommentItem.prototype, "editable", void 0);
CommentItem = __decorate([
    (0, decorators_js_1.customElement)('mm-comment-item')
], CommentItem);
exports.CommentItem = CommentItem;
//# sourceMappingURL=data:application/json;base64,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